"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _ref;

var _default = new _immutable.Record((_ref = {}, (0, _defineProperty2.default)(_ref, _constants.PageProperties.ID, null), (0, _defineProperty2.default)(_ref, _constants.PageProperties.NAME, null), (0, _defineProperty2.default)(_ref, _constants.PageProperties.URL, null), (0, _defineProperty2.default)(_ref, _constants.PageProperties.PUBLIC_ACCESS_RULES_ENABLED, null), _ref), _constants.SITE_PAGES);

exports.default = _default;
module.exports = exports.default;